import { render } from "./mat-navigation.vue?vue&type=template&id=03a3aa04&scoped=true&lang=true"
import script from "./mat-navigation.vue?vue&type=script&lang=js"
export * from "./mat-navigation.vue?vue&type=script&lang=js"

import "./mat-navigation.vue?vue&type=style&index=0&id=03a3aa04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a3aa04"]])

export default __exports__